// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__l2MED","label":"SetPasswdForm_label__2VYLL"};